// TODO: rewrite to WSC

const Info = () => {
  return (
    <div
      style={{
        margin: 'auto',
        width: '100%',
        maxWidth: '1000px',
        padding: '16px',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          border: '1px solid #eaeaea',
          borderRadius: '8px',
          padding: '16px',
        }}
      >
        <h1 style={{ marginTop: 0 }}>Trackman ved Rungsted Golf Klub - Privatlivspolitik</h1>
        <p>
          På denne side kan du læse nærmere om, hvordan vi behandler oplysning om dig efter GDPR artikel 14 ift. den testopstilling Trackman
          har ved Rungsted Golf Klub.
        </p>
        <h2>1.Vi er den dataansvarlige -- hvordan kontakter du os?</h2>
        <p>
          Trackman er dataansvarlig for behandlingen af de personoplysninger, som vi har modtaget om dig. Du finder vores kontaktoplysninger
          nedenfor.
        </p>
        <ul>
          <li>Trackman A/S</li>
          <li>Dr Neergaards Vej 15</li>
          <li>2970 Hørsholm</li>
          <li>CVR-nr.: 27352677</li>
          <li>Telefon: 22498827</li>
          <li>Mail: ula@trackman.com</li>
        </ul>

        <h2>2.Formålene med og retsgrundlaget for behandlingen af dine personoplysninger</h2>
        <p>
          Trackman har opsat udstyr på Rungsted Golf Klubs bane, hvor dine golfslag kan blive optaget og analyseret. Hvis du ikke ønsker at
          Trackman skal optage dig, kan du trykke på knappen på siden af udstyret inden du skal slå dit slag.
        </p>
        <p>Ved ikke at trykke på knappen samtykker du til, at Trackman optager dig jf. GDPR artikel 6, stk. 1, litra a.</p>

        <h2>3.Kategorier af personoplysninger</h2>
        <p>Når vi optager dit golfslag på banen, behandler vi almindelige personoplysninger om dig.</p>

        <h2>4.Modtagere eller kategorier af modtagere</h2>
        <p>Vi behandler selv dine personoplysninger, og videregiver dem kun til databehandlere med hvem vi har indgået aftaler med.</p>

        <h2>5.Overførsel til modtagere i tredjelande, herunder internationale organisationer</h2>
        <p>
          Når vi overfører dine personoplysninger til databehandlere uden for EU og EØS, sikrer vi altid dine oplysninger bliver behandlet
          sikkert.
        </p>

        <h2>6.Opbevaring af dine personoplysninger</h2>
        <p>
          Vi kan på nuværende tidspunkt ikke sige, hvor længe vi vil opbevare dine personoplysninger. Dog kan vi oplyse dig om, at vi vil
          lægge vægt på at vi kun holder dine oplysninger, så længe oplysningerne er nødvendige. Herefter vil oplysningerne om dig blive
          slettet.
        </p>
        <h2>7.Retten til at trække samtykke tilbage</h2>
        <p>
          Du har til enhver tid ret til at trække dit samtykke tilbage. Dette kan du gøre ved at kontakte os på de kontaktoplysninger, der
          fremgår ovenfor i punkt 1.
        </p>
        <p>
          Hvis du vælger at trække dit samtykke tilbage, påvirker det ikke lovligheden af vores behandling af dine personoplysninger på
          baggrund af dit tidligere meddelte samtykke og op til tidspunktet for tilbagetrækningen.
        </p>
        <p>Hvis du tilbagetrækker dit samtykke, har det derfor først virkning fra dette tidspunkt.</p>

        <h2>8.Dine rettigheder</h2>
        <p>Du har efter databeskyttelsesforordningen en række rettigheder i forhold til vores behandling af oplysninger om dig.</p>
        <p>Hvis du vil gøre brug af dine rettigheder skal du kontakte os.</p>
        <p style={{ fontWeight: 600 }}>Ret til at se oplysninger (indsigtsret)</p>
        <p>Du har ret til at få indsigt i de oplysninger, som vi behandler om dig, samt en række yderligere oplysninger.</p>
        <p style={{ fontWeight: 600 }}>Ret til berigtigelse (rettelse)</p>
        <p>Du har ret til at få urigtige oplysninger om dig selv rettet.</p>
        <p style={{ fontWeight: 600 }}>Ret til sletning</p>
        <p>
          I særlige tilfælde har du ret til at få slettet oplysninger om dig, inden tidspunktet for vores almindelige generelle sletning
          indtræffer.
        </p>
        <p style={{ fontWeight: 600 }}>Ret til begrænsning af behandling</p>
        <p>
          Du har visse tilfælde ret til at få behandlingen af dine personoplysninger begrænset. Hvis du har ret til at få begrænset
          behandlingen, må vi fremover kun behandle oplysningerne - bortset fra opbevaring - med dit samtykke, eller med henblik på at
          retskrav kan fastlægges, gøres gældende eller forsvares, eller for at beskytte en person eller vigtige samfundsinteresser.
        </p>
        <p style={{ fontWeight: 600 }}>Ret til indsigelse</p>
        <p>Du har i visse tilfælde ret til at gøre indsigelse mod vores eller lovlige behandling af dine personoplysninger.</p>
        <p>Du kan også gøre indsigelse mod behandling af dine oplysninger til direkte markedsføring.</p>
        <p style={{ fontWeight: 600 }}>Ret til at transmittere oplysninger (dataportabilitet)</p>
        <p>
          Du har i visse tilfælde ret til at modtage dine personoplysninger i et struktureret, almindeligt anvendt og maskinlæsbart format
          samt at få overført disse personoplysninger fra én dataansvarlig til en anden uden hindring.
        </p>
        <p>
          Du kan læse mere om dine rettigheder i Datatilsynets vejledning om de registreredes rettigheder, som du finder på
          <a href='https://www.datatilsynet.dk/'>www.datatilsynet.dk</a>.
        </p>
        <h2>9.Klage til Datatilsynet</h2>
        <p>
          Du har ret til at indgive en klage til Datatilsynet, hvis du er utilfreds med den måde, vi behandler dine personoplysninger på. Du
          finder Datatilsynets kontaktoplysninger på
          <a href='https://www.datatilsynet.dk/'>www.datatilsynet.dk</a>.
        </p>
      </div>
    </div>
  );
};

export default Info;
